import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

const PrivateRoute = ({ children, requireProfile = true }) => {
  const token = localStorage.getItem('token');
  const [profileStatus, setProfileStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const checkProfileStatus = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await api.get('/auth/me');
        setProfileStatus(response.data.user.profileCompleted);
      } catch (error) {
        console.error('Error checking profile status:', error);
        // Fallback to localStorage if API fails
        const userData = JSON.parse(localStorage.getItem('user') || '{}');
        setProfileStatus(userData.profileCompleted || false);
      } finally {
        setLoading(false);
      }
    };

    checkProfileStatus();
  }, [token]);

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (requireProfile && !profileStatus) {
    return <Navigate to="/profile-setup" />;
  }

  if (!requireProfile && profileStatus) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
